import { Box, CircularProgress, Typography } from "@mui/material";
import { useGetInvoice } from "../ClientView/hooks/useGetInvoice";
import { InvoiceDetailsView } from "./index";

interface InvoiceDetailsByUidProps {
  invoiceUid: string;
  scopeOfWorkUid?: string;
}

/**
 * Fetches invoice by UID and renders InvoiceDetailsView.
 * Used when opening invoice from notification (no invoice object available).
 */
export const InvoiceDetailsByUid = ({ invoiceUid, scopeOfWorkUid }: InvoiceDetailsByUidProps) => {
  const { data: invoice, isLoading, isError, refetch } = useGetInvoice(invoiceUid);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200, p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !invoice) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">Error loading invoice or invoice not found.</Typography>
      </Box>
    );
  }

  return (
    <InvoiceDetailsView
      invoiceUid={invoiceUid}
      scopeOfWorkUid={scopeOfWorkUid ?? invoice.scopeOfWorkUid} //IMPORTANT: HOW to deal with scope of work uid?
      refetchInvoice={() => refetch()}
    />
  );
};
